export default "__VITE_ASSET__oqw6uv19__"